import {Card, CardActionArea, CardContent, CardMedia, Typography} from '@material-ui/core';
import replace from 'lodash/replace';
import {CSSProperties, useState} from 'react';
import {WithTranslation, withTranslation} from 'react-i18next';
import {Link} from 'react-router-dom';

import {ICaseModel} from 'src/Data/Cases/ICaseModel';
import EnumRoutes from 'src/Routes/EnumRoutes';
import {getRoutePathname} from 'src/Routes/getRoutePathname';

const CasesSlide = (props: ICasesSlide) => {
	const [isHovered, setIsHovered] = useState(false);
	const styles: CSSProperties = {
		overflow: 'visible',
		transition: 'all .2s ease-in-out',
	};

	const onMouseEnter = () => {
		if (props.shouldGrowOnHover) {
			setIsHovered(true);
		}
	};

	const onMouseLeave = () => {
		if (props.shouldGrowOnHover) {
			setIsHovered(false);
		}
	};

	if (isHovered) {
		styles.transform = 'scale(1.05)';
	}

	return (
		<Card
			elevation={0}
			className={props.cardClassName}
			style={styles}
			onMouseEnter={onMouseEnter}
			onMouseLeave={onMouseLeave}
		>
			<CardActionArea
				disableRipple
				disableTouchRipple
				className={props.sliderLinkClassName}
				to={replace(getRoutePathname(EnumRoutes.CASE, {language: props.i18n.language}), ':caseId', props.item.slug)}
				component={Link}
			>
				<CardMedia
					component="img"
					src={props.item.preview}
					title={props.item.title}
					className={props.sliderCardMediaClassName}
				/>
				<CardContent className={props.sliderCardContentClassName}>
					<Typography gutterBottom variant="body2">
						{props.item.title}
						<br />
						<small>{props.item.client}</small>
					</Typography>
				</CardContent>
			</CardActionArea>
		</Card>
	);
};

interface ICasesSlide extends WithTranslation {
	cardClassName?: string;
	sliderCardContentClassName?: string;
	sliderCardMediaClassName?: string;
	sliderLinkClassName?: string;
	item: ICaseModel;
	shouldGrowOnHover: boolean;
}

export default withTranslation('common')(CasesSlide);
